import "./styles/style.css";

export const getCustomPlacemark = (
  id,
  geometry,
  onClick,
  name,
  jobChart,
  radius = 15,
  onClickPopUp,
  onTaskStateClick
) => {
  window.handleNavigate = (props, id) => {
    onTaskStateClick(id, props);
  };

  window.goToObject = (id) => {
    onClickPopUp(id);
  };

  // Логика определения цвета как в DonutChart
  const sumOfValue = jobChart?.fireMessagesAmount + jobChart?.falseFireMessagesAmount;
  const fillColor = sumOfValue > 0 ? "#FB0004" : "#20ac20 ";

  // SVG для круга
  const svgContent = `
    <svg width="${radius * 2}" height="${radius * 2}" xmlns="http://www.w3.org/2000/svg">
      <circle cx="${radius}" cy="${radius}" r="${radius}" fill="${fillColor}" />
    </svg>
  `;

  return {
    type: "Feature",
    id: id,
    onClick: onClick,
    geometry: {
      type: "Point",
      coordinates: geometry,
    },
    options: {
      iconLayout: "default#image",
      iconImageHref: `data:image/svg+xml;utf-8,${encodeURIComponent(svgContent)}`,
      iconImageSize: [radius * 2, radius * 2],
      iconImageOffset: [-radius, -radius],
      cursor: "pointer",
    },
    properties: {
      balloonContentHeader: `<strong style="display: -webkit-box;
                            overflow: hidden;
                            -webkit-line-clamp: 2;
                            -webkit-box-orient: vertical; font-family: var(--INTER)">${name}</strong>`,
      balloonContentBody: `
          <div class="balloon_content">
            <ul class="balloon_content-list">
              <li class="balloon_content-list-item">
                <p onclick="window.handleNavigate('fire_messages_amount', '${id}')" class="link-black">
                  <span class="link_point" style="background-color: #fb0104;"></span>
                  Количество сообщений 'пожар' за смену: ${jobChart?.fireMessagesAmount || 0}
                </p>
              </li>
              <li class="balloon_content-list-item">
                <p onclick="window.handleNavigate('false_fire_messages_amount', '${id}')" class="link-black">
                  <span class="link_point" style="background-color: #ff6800;"></span>
                  Количество ложных сообщений 'пожар' за смену: ${jobChart?.falseFireMessagesAmount || 0}
                </p>
              </li>
            </ul>
          </div>
        `,
      balloonContentFooter: `
          <div class="balloon_footer">
            <p
              class="balloon_footer-text"
              onclick="window.goToObject('${id}')"
            > 
              Подробнее...
            </p>          
          </div>
        `,
      clusterCaption: `<strong style="display: -webkit-box;
                            overflow: hidden;
                            -webkit-line-clamp: 2;
                            -webkit-box-orient: vertical; font-family: var(--INTER)">${name}</strong>`,
    },
    modules: ["geoObject.addon.balloon", "geoObject.addon.hint"],
    defaultState: { balloon: { open: true } },
    instanceRef: (ref) => ref && ref.balloon && ref.balloon.close(),
  };
};
